// Header functionality for Wolf Construct
let drawerLevel = 0;

document.addEventListener('DOMContentLoaded', function() {
  console.log('Header JS loaded'); // Debug log  
  // Initialize header components
  initMobileMenu();
  // initSearch();
  initChildMenus();
  
  // Handle window resize
  // window.addEventListener('resize', handleResize);
});

// Mobile Menu Functionality
function initMobileMenu() {
  
  const menuWrappers = document.querySelectorAll('.main-menu-wrapper');
  
  menuWrappers.forEach(wrapper => {
    const menuToggle = wrapper.querySelector('.main-menu-toggle');
    const menu = wrapper.querySelector('.main-menu');
    
    if (menuToggle) {
      menuToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = wrapper.hasAttribute('open');
        
        if (isOpen) {
          if (this.dataset.childId && this.classList.contains('main-menu-toggle--back')) {
            let targetId = this.dataset.childId;
            let targetPanel = document.querySelector(`#${targetId}`);
            if (targetPanel) {
              let backButton = targetPanel.querySelector('.main-menu-panel__back-link');
              const clickEvent = new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window
              });
              backButton.dispatchEvent(clickEvent); 
            }
          }else {
            closeMobileMenu(wrapper);
          }
        } else {
          openMobileMenu(wrapper);
        }
      });
    }
    
    // Close menu when clicking outside
    document.addEventListener('click', function(event) {
      if (!wrapper.contains(event.target) && wrapper.hasAttribute('open')) {
        closeMobileMenu(wrapper);
      }
    });
  });
  
  // Close all mobile menus function
  function closeMobileMenu(wrapper) {
    wrapper.removeAttribute('open');
    document.body.classList.remove('menu-open');
    
    // Close any open child menus
    // const childPanels = wrapper.querySelectorAll('.main-menu-panel--child[aria-hidden="false"]');
    // childPanels.forEach(panel => {
    //   panel.setAttribute('aria-hidden', 'true');
    //   panel.style.transform = 'translateX(100%)';
    // });
    // resetMenuPanels();
  }
  
  function openMobileMenu(wrapper) {
    wrapper.setAttribute('open', '');
    document.body.classList.add('menu-open');
  }
}

// Function to reset all menu panels to default state
function resetMenuPanels() {
  drawerLevel = 0;
  const header = document.querySelector('[data-header]');
  const menuToggle = header.querySelector('.main-menu-toggle');
  // Hide all child panels
  menuToggle.classList.remove('main-menu-toggle--back');
  const childPanels = header.querySelectorAll('.main-menu-panel--child');
  childPanels.forEach(panel => {
    panel.classList.add('main-menu-panel--inactive-right');
    panel.setAttribute('aria-hidden', 'true');
  });
  
  // Reset active states on menu items if needed
  const allPanels = header.querySelectorAll('.main-menu-panel');
  allPanels.forEach(item => {
    item.classList.remove('main-menu-panel--inactive-left');
    item.setAttribute('aria-hidden', 'true');
    if (item.classList.contains('parent-panel')) {
      return;
    } else {
      item.classList.remove('main-menu-panel--inactive-left');
      item.classList.add('main-menu-panel--inactive-right');
    }
    
  });
}
// Child Menu Panels
function initChildMenus() {
  console.log('Initializing child menus'); // Debug log
  const menuWrapper = document.querySelector('.main-menu-wrapper');
  const menuToggle = menuWrapper.querySelector('.main-menu-toggle');
  
  // Open child menus
  const menuLinks = document.querySelectorAll('.main-menu-link[aria-haspopup="true"]');
  
  menuLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const targetId = this.getAttribute('aria-controls');
      const targetPanel = document.getElementById(targetId);
      this.closest('.main-menu-panel').classList.add('main-menu-panel--inactive-left');
      if (targetPanel) {
        e.preventDefault();
        openChildPanel(targetPanel, menuToggle);
      }
    });
  });
  
  // Back buttons
  const backButtons = document.querySelectorAll('.main-menu-panel__back-link');
  
  backButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').replace('#', '');
      const targetPanel = document.getElementById(targetId);
      const parent = this.closest('.main-menu-panel');
      const menuToggle = menuWrapper.querySelector('.main-menu-toggle');

      if (targetPanel) {
        closeChildPanel(parent, menuToggle);
        parent.classList.add('main-menu-panel--inactive-right');
        menuToggle.dataset.childId = targetId;
        setTimeout(() => {
          targetPanel.classList.remove('main-menu-panel--inactive-left');
        }, 400);
      }
    });
  });
  
  function openChildPanel(panel, menuToggle) {
    drawerLevel++;
    panel.setAttribute('aria-hidden', 'false');
    panel.style.transform = 'translateX(0)';
    panel.style.visibility = 'visible';
    panel.style.opacity = 1;
    setTimeout(() => {
      panel.classList.remove('main-menu-panel--inactive-right');
    }, 400);
    // console.log(panel.classList);
    if (drawerLevel > 0) {
      menuToggle.classList.add('main-menu-toggle--back');
    }
    let targetId = panel.id;
    menuToggle.dataset.childId = targetId;
  }
  
  function closeChildPanel(panel, menuToggle) {
    drawerLevel--;
    panel.setAttribute('aria-hidden', 'true');
    panel.style.transform = 'translateX(10%)';
    setTimeout(() => {
      panel.style.visibility = 'hidden';
    }, 300);
    if (drawerLevel == 0) {
      menuToggle.classList.remove('main-menu-toggle--back')
    }
  }
}

// Window Resize Handler
function handleResize() {
  const menuWrappers = document.querySelectorAll('.main-menu-wrapper[open]');
  
  if (window.innerWidth > 768) {
    // Close mobile menu on desktop
    menuWrappers.forEach(wrapper => {
      wrapper.removeAttribute('open');
      document.body.classList.remove('menu-open');
    });
    
    // Close all child panels
    const childPanels = document.querySelectorAll('.main-menu-panel--child');
    childPanels.forEach(panel => {
      panel.setAttribute('aria-hidden', 'true');
      panel.style.transform = 'translateX(100%)';
      panel.style.visibility = 'hidden';
    });
  }
  // resetMenuPanels();
}